export default __webpack_public_path__ + "static/NNNittiGrotesk-TextMedium-b777b209696697fa166a9792a441dc8c.woff";